import React from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { AI_TEMPLATE_STATUSES } from "@/model/interface/AiAgent";
import { TemplateFormValues } from "../templateForm";

export default function TemplatePublishSection({
  isNew,
  savedStatus,
  onDeploy,
  onCreateListing,
}: {
  isNew: boolean;
  savedStatus?: string;
  onDeploy: () => void;
  onCreateListing: () => void;
}) {
  const form = useFormContext<TemplateFormValues>();

  return (
    <Card>
      <CardHeader>
        <CardTitle>Status and Next Steps</CardTitle>
        <CardDescription>Only published templates can be listed in the marketplace</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <FormField control={form.control} name="status" render={({ field }) => (
          <FormItem className="max-w-sm">
            <FormLabel>Status</FormLabel>
            <Select value={field.value} onValueChange={field.onChange}>
              <FormControl><SelectTrigger><SelectValue /></SelectTrigger></FormControl>
              <SelectContent>
                {AI_TEMPLATE_STATUSES.map((status) => (
                  <SelectItem key={status.value} value={status.value}>{status.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </FormItem>
        )} />

        <div className="space-y-2">
          <div className="flex flex-wrap gap-2">
            <Button type="button" variant="outline" disabled={isNew} onClick={onDeploy}>
              Deploy to organisation
            </Button>
            <Button
              type="button"
              variant="outline"
              disabled={isNew || savedStatus !== "PUBLISHED"}
              onClick={onCreateListing}
            >
              Create listing
            </Button>
          </div>
          <p className="text-sm text-muted-foreground">
            {isNew
              ? "Create the template first. These steps unlock as soon as it is saved."
              : "Deploy gives an organisation an agent built on this template. Listing needs the saved status to be Published."}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
